/** Iter 43 — plain labels + grouping for impact-graph nodes. Pure functions, no React. */

const KIND_LABEL = { program: "Program", file: "File", logical_file: "File", field: "Field", unknown: "Unknown" };
const ORIGIN_LABEL = { parsed: "Parsed source", referenced: "Referenced only" };

export const EMPTY_TEXT = {
  programs: "No programs in this graph.",
  files: "No files in this graph.",
  others: "No other objects in this graph.",
  fields: "No deterministic field references for the objects in this graph. Rebuild field references or parse the programs first.",
};

export function kindLabel(kind) {
  return KIND_LABEL[kind] || KIND_LABEL.unknown;
}

/** Secondary tag; empty string for catalog-backed nodes (nothing to call out). */
export function originLabel(origin) {
  return ORIGIN_LABEL[origin] || "";
}

/** Split graph nodes into the blast-radius panels. Root excluded from object panels; nothing is dropped. */
export function groupImpactNodes(graph) {
  const rootId = graph?.root?.id;
  const groups = { programs: [], files: [], fields: [], others: [] };
  for (const n of graph?.nodes || []) {
    if (n.kind === "field") { groups.fields.push(n); continue; }
    if (n.id === rootId) continue;
    if (n.kind === "program") groups.programs.push(n);
    else if (n.kind === "file" || n.kind === "logical_file") groups.files.push(n);
    else groups.others.push(n);
  }
  return groups;
}
